import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Grid } from "@material-ui/core";
import { withRouter, Link } from "react-router-dom";
import "./Confirmation.css";
import _ from "lodash";
import imageBackground from "../img/background-images-2025.jpg"

@inject("userStore", "authStore")
@withRouter
@observer
class Confirmation extends Component {
    state = {
        activeResend: false,
        counter: 30,
        headerInfo: "We need to be sure it's you!",
        emailConfirmation: ""
    }
    componentWillMount() {
        this.props.authStore.reset();

        if (this.props.location && !this.props.location.search) {
            setTimeout(() => {
                this.setState({activeResend: true})
            }, 30000);
            this.setState({counter:30})
            this.startCounter()
        }

        const emailConfirmation = localStorage.getItem("email-confirmation")
        if(emailConfirmation) {
            this.props.authStore.setEmail(emailConfirmation);
            this.setState({emailConfirmation})
        }
        
        if (this.props.location && this.props.location.search) {
            this.params = _.chain(this.props.location.search)
                .replace("?", "")
                .split("&")
                .map(_.ary(_.partial(_.split, _, "="), 1))
                .fromPairs()
                .value();

            this.props.authStore.setEmail(this.params.email);
            this.props.authStore.setConfirmationToken(this.params.code);

            this.props.authStore.confirmationToken().then(response => {
                localStorage.setItem("email-confirmation", this.params.email?this.params.email:"")
                if(this.params.code) {
                    this.setState({counter:5})
                    this.startCounter()
                    setTimeout(() => {
                        this.props.history.push(`/sign-in`);
                    }, 5000);
                }
            });
        }
    }

    handleResendEmail = () => {
        this.props.authStore.resendVerificationCode(this.state.emailConfirmation)
        .then(() => {
            this.setState({activeResend: false, headerInfo: "Verification email sent!"})
            this.startCounter()
            setTimeout(() => {
                this.setState({activeResend: true})
            }, 30000);
            this.setState({counter:30})
        })
    }

    startCounter = () => {
        if(this.state.counter > 0) {
            setInterval(() => {
               if (this.state.counter > 0) this.setState({counter:this.state.counter - 1})
            }, 1000);
        }
    }

    getProgressWidth = () => {
        const total = this.params?.code ? 5 : 30;
        return ((total - this.state.counter) / total) * 100;
    }

    renderVerifiedView() {
        return (
            <div className="confirmation-container">
                <div className="success-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                </div>

                <div className="success-badge">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                    <span>Email verified successfully</span>
                </div>

                <h1 className="confirmation-title">You're all set!</h1>
                <p className="confirmation-subtitle">
                    Your email has been verified. You can now sign in and start using Hot Giggity.
                </p>

                <div className="countdown-card">
                    <p className="countdown-label">Redirecting you to Sign In</p>
                    <div className="countdown-timer">
                        <span className="countdown-number">{this.state.counter}</span>
                        <span className="countdown-text">
                            <span>seconds</span>
                            <span>remaining</span>
                        </span>
                    </div>
                    <div className="progress-bar-container">
                        <div className="progress-bar" style={{ width: `${this.getProgressWidth()}%` }}></div>
                    </div>
                </div>

                <Link to="/sign-in" className="action-button">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                        <polyline points="10 17 15 12 10 7"></polyline>
                        <line x1="15" y1="12" x2="3" y2="12"></line>
                    </svg>
                    Sign In Now
                </Link>

                <p className="fallback-text">
                    Not redirected? <Link to="/sign-in">Click here to sign in manually</Link>
                </p>
            </div>
        );
    }

    renderPendingView() {
        const email = this.state.emailConfirmation;
        return (
            <div className="confirmation-container">
                <div className="pending-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <rect x="3" y="5" width="18" height="14" rx="2"></rect>
                        <polyline points="3 7 12 13 21 7"></polyline>
                    </svg>
                </div>

                <h1 className="confirmation-title">{this.state.headerInfo}</h1>
                <p className="confirmation-subtitle">
                    Please check your inbox to verify your email and complete the sign up process.
                </p>

                <div className="info-card">
                    <div className="info-card-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="16" x2="12" y2="12"></line>
                            <line x1="12" y1="8" x2="12.01" y2="8"></line>
                        </svg>
                    </div>
                    <div className="info-card-content">
                        <strong>Check your spam folder</strong>
                        <p>Sometimes verification emails end up in spam or junk folders.</p>
                    </div>
                </div>

                {this.state.activeResend ? (
                    <div className="resend-section">
                        <p className="resend-text">Didn't receive the email?</p>
                        <button className="resend-button" onClick={this.handleResendEmail}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polyline points="23 4 23 10 17 10"></polyline>
                                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
                            </svg>
                            Resend Verification Email
                        </button>
                        {email && <p className="email-hint">Will be sent to {email}</p>}
                    </div>
                ) : (
                    <div className="wait-section">
                        <div className="wait-timer">
                            <span className="wait-number">{this.state.counter}</span>
                            <span className="wait-label">seconds until you can resend</span>
                        </div>
                        <div className="progress-bar-container">
                            <div className="progress-bar" style={{ width: `${this.getProgressWidth()}%` }}></div>
                        </div>
                    </div>
                )}

                <Link to="/sign-in" className="secondary-link">
                    Already verified? Sign in here
                </Link>
            </div>
        );
    }

    render() {
        return (
            <div style={{ backgroundImage: `url(${imageBackground})`}} className="Confirmation">
                <Grid container className="main-grid" justify="center">
                    <Grid container spacing={24} justify="center">
                        <Grid item xs={12} sm={10} md={8} lg={6}>
                            {this.params?.code ? this.renderVerifiedView() : this.renderPendingView()}
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default Confirmation;
